module.exports = __webpack_public_path__ + "media/images/illustrations/online-tutoring-01-7b9fbcc134f8308e1fe7a3ef1dcaec90.svg";